<template>
  <div class="dashboard-container">
    <Navbar />

    <!-- Login Modal -->
    <b-modal id="login-modal" ref="modal" hide-header hide-footer centered no-close-on-backdrop>
      <div class="text-center login-modal-content">
        <div class="logo-container mb-3">
          <img src="@/assets/images/logodark.png" alt="EDDCallerOne" class="logo-image">
        </div>
        <h5 class="text-uppercase text-primary font-weight-bold mb-3">
          Sign-in or Register With Your Mobile Phone Number
        </h5>
        <p class="text-muted small mb-4">We'll send a text to verify your number, and use this number to call you when we reach a representative.</p>
      
        <div class="login-form">
          <form @submit.prevent="submit" v-if="!smsSent">
            <div class="form-group">
              <vue-tel-input v-model="phoneNumber" v-bind="bindProps"></vue-tel-input>
            </div>

            <div id="recaptcha-container" class="recaptcha-wrapper"></div>

            <div class="text-center mt-4">
              <button class="btn btn-primary btn-lg btn-block" id="log-in" type="submit">
                Next
              </button>
            </div>
          </form>

          <div v-if="smsSent" class="otp-container">
            <div class="mb-3">
              <input 
                type="text" 
                id="otpField"
                class="form-control text-center otp-input"
                pattern="[0-9]{6}"
                maxlength="6"
                v-model="otpnum"
                placeholder="Enter Verification Code"
                required
              >
            </div>
            <div>
              <button class="btn btn-primary btn-lg btn-block" @click="verifyCode" id="otp-btn">Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    
    <div v-scroll-spy>
      <!-- Hero Section -->
      <section
        class="hero-section"
        :style="{'background-image': 'url(' + require('@/assets/images/hero-1-bg-img.png') + ')'}"
        id="home"
      >
        <div class="container py-5">
          <div class="dashboard-header mb-4">
           <br>
            <h1 class="text-center font-weight-bold">Dashboard</h1>
            <div class="dashboard-divider"></div>
            <!--<b-alert show variant="danger">Calls purchased July 4th will not start until Monday July 7th. Sorry for the inconvenience. Please return to this page Monday to click start call.</b-alert>-->
          </div>



          <!-- Purchase Call Section -->
          <div v-if="fbdata.callStatus === 'Done'" class="dashboard-card mb-4">
            <div class="card-header">
              <h4 class="text-center mb-0">Purchase Call</h4>
            </div>
            <div class="card-body">
              <div class="row justify-content-center">
                <div class="col-lg-8">
                  <div id="sq-ccbox" class="payment-box">
                    <b-form-select 
                      id="options" 
                      v-model="selected" 
                      :options="options" 
                      @change="handleDropdownChange" 
                      class="custom-select mb-3"
                    ></b-form-select>
                    
                    <p v-if="statfound" class="stats-info mb-4">
                      The average number of calls to get through to 
                      <span class="font-weight-bold">{{ statdata.name }}</span> is 
                      <span class="font-weight-bold">{{ statdata.Avg_Attempts }}</span>, which takes EDD Caller approximately 
                      <span class="font-weight-bold">{{ statdata.EDDCaller_Avg }}</span> minutes.
                    </p>
                    
                    <form id="payment-form" class="payment-form">
                      <div id="card-container" class="card-container"></div>
                    </form>
                    <div id="payment-status-container"></div>
                  </div>
                </div>
              </div>  
              
              <div class="row justify-content-center mb-3">
                <b-form-checkbox v-model="autostartEnabled" switch class="autostart-toggle">
                  <span class="autostart-label">Auto-start (recommended)</span>
                </b-form-checkbox>
              </div>
              
              <div class="row justify-content-center">
                <button 
                  v-show='paymentSubmit' 
                  :disabled="selected == null" 
                  @click="requestCardNonce($event)" 
                  class="btn btn-primary btn-lg payment-button"
                >
                  Pay ${{cost}}
                </button>
              </div>
            </div>
            
            <div class="card-footer bg-transparent">
              <b-alert show class="alert-info mb-3">
                Once started, you will be called after the program detects the hold line. Current estimated wait times to speak with a live representative are listed on the homepage and are updated hourly.
                There is unlimited calling for one day with each payment. If you're not satisfied with the results of a call, feel free to initiate another call for that particular line within the same day without any additional cost.
              </b-alert>
              
            </div>
          </div>

          <!-- Ready to Call Section -->
          <div v-else-if="fbdata.callStatus === 'Ready to Call'" class="dashboard-card mb-4">



            <div class="card-body">
              <div class="text-center mb-4">
                <button @click="placeCall()" class="btn btn-primary btn-lg start-call-button">
                  Start Now!
                </button>
              </div>
              
              <b-card-text v-if="fbdata.CallTries !== null && fbdata.CallTries >= 1" class="alert alert-warning d-flex align-items-center mb-4" role="alert">
                <i class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2 warning-icon"></i>
                <div>
                  EDDCaller has successfully connected to a hold line and we've called you <strong>{{ fbdata.CallTries }}</strong> time(s). If you missed <u>any</u> calls, you need to turn off call screening before starting another call.
                </div>
              </b-card-text>
              
              <b-alert variant="success" show class="mb-4">
                <h5 class="alert-heading">Note:</h5>
                <p class="mb-2">If you start the call outside our calling hours the program will wait until the next day and start calling automatically when office hours start. Calls after the listed time are deferred until the next day.</p>
                <p class="mb-0">
                  Once your call successfully gets through to be placed on hold, you will receive a call from a <strong>559</strong> or <strong>805</strong> area code and direct callbacks come from an <strong>844</strong> number. It is likely that you will need to turn off call screening from unknown numbers on your phone.
                </p>
              </b-alert>

              <div class="calling-hours mb-3">
                <h4 class="mb-3">Calling Hours:</h4>
                <div class="table-container">
                  <table v-for="stateInfo in lines" v-if="fbdata.state === stateInfo.id" class="table table-striped table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th>Call Option</th>
                        <th>Number</th>
                        <th>Open</th>
                        <th>Close</th>
                        <th>Time Zone</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ stateInfo.name }}</td>
                        <td>{{ stateInfo.phoneNumber }}</td>
                        <td>{{ stateInfo.hours['open'] }}</td>
                        <td>{{ stateInfo.hours['close'] }}</td>
                        <td>{{ stateInfo.hours['time_zone'] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Call Status Section -->
          <div v-else class="dashboard-card mb-4">



            <div class="card-header">
              <h4 class="mb-0">Call Status</h4>
            </div>
            <div class="card-body">

              <div v-if="fbdata.callStatus === 'Calling'" class="text-center mb-4">
                <button @click="pauseCall()" class="btn btn-primary btn-lg start-call-button">
                  Stop Calling
                </button>
              </div>

              <div class="call-status-indicator mb-3">
                <status-indicator status="positive" pulse="true"/> 
                <span class="status-text">{{fbdata.callStatus}}</span>
                <small class="text-muted d-block mt-1">(Attempts: {{fbdata.attempts}})</small>
              </div>
              
              <b-alert v-if="fbdata.callStatus === 'Calling'" variant="success" show class="mb-3">
                <p class="mb-0">Once your call successfully gets through to be placed on hold, you will receive a call from a <strong>559</strong> or <strong>805</strong> area code. Your dashboard will always update to show the call status, but you are not required to stay on this page to receive a call. If we can't reach you by phone, your account will reset and you'll have to click the "Start Now" button. During busy periods, missed or screened calls will lower your priority for future attempts. Please note that most phones screen unknown numbers by default - you'll need to disable this feature to receive our call.</p>
              </b-alert>

              <b-alert v-if="fbdata.callStatus === 'Waiting on Calling Hours'" variant="success" show class="mb-3">
                <p class="mb-0">The line you're trying to reach is closed. Our system will start to call within 30 seconds of the line opening on the next business day.</p>
              </b-alert>


              <b-alert v-if="fbdata.state === 'cadisability' || fbdata.state === 'capfl'" variant="warning" show class="mb-3">
                <h5 class="alert-heading">Notice for SDI and PFL:</h5>
                <p class="mb-0">When you receive the call, do not press 1 to receive a callback because that will call our 559 number. Instead, press 2 to enter your number. If your status says, "Callback Queue Verified. Please wait for direct call." you will receive a call directly from the departments 844 number.</p>
              </b-alert>


            </div>
          </div>

          <!-- Profile Information Section -->

          <div v-if="account" class="dashboard-card">
            <div class="card-header">
              <h4 class="mb-0">Profile Information</h4>
            </div>
            <div class="card-body">
              <div class="profile-info">
                <p class="mb-2"><strong>Contact Phone Number:</strong> {{number}}</p>
                <p class="mb-3"><strong>Support ID:</strong> {{uid}}</p>
                <a :href="fbdata.receiptURL" target="_blank" class="btn btn-outline-primary">View Last Receipt</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
    
    <!-- Support Sidebar -->
    <b-sidebar id="sidebar" title="Support and FAQ" shadow>
      <div class="px-3 py-3">
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
                <path fill-rule="evenodd" d="M11.5 7a4.499 4.499 0 11-8.998 0A4.499 4.499 0 0111.5 7zm-.82 4.74a6 6 0 111.06-1.06l3.04 3.04a.75.75 0 11-1.06 1.06l-3.04-3.04z"></path>
              </svg>
            </span>
          </div>
          <input 
            type="text" 
            class="form-control" 
            v-model="searchQuery" 
            placeholder="Search..." 
            aria-label="Search"
          >
        </div>
      </div>
      
      <div class="faq-content">
        <div class="px-3 py-3 faq-item" v-for="post of resultQuery">
          <h5 class="faq-title">{{post.title}}</h5>
          <div v-html="post.body" class="faq-body"></div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import firebase from "firebase";
import Navbar from "@/components/dashnav";
import Footer from "@/components/footer";
import axios from 'axios';

export default {
  name: "paymentForm",
  data() {
    return {
      autostartEnabled: true,
      searchQuery: null,
      postList: [
        {title: 'Getting Started', body: 'To begin, you need to prepay for a call. We utilize SquareUp Payments to ensure secure transactions on our platform. Our automated system is designed to make several simultaneous calls, and once the first line reaches a hold line, we call you and connect the lines.'},
        {title: 'What If My Call Gets Disconnected?', body: 'If the hold line disconnects or your representative ends the call, you can initiate a new call at no additional cost by clicking Start again. For any other issues, please contact us via chat on our website or by emailing support@EDDCaller.com, and we will reset your account for another call.'},
        {title: 'Why Do Calling Hours Vary?', body: 'Calls made after the specified time will be postponed until the next day, as the call center may disconnect your call while you are on hold if they close. If you start the call outside our calling hours, it will be delayed until the next day and begin automatically when office hours commence.'},
        {title: 'What If I\'m Unavailable When Called?', body: 'Our system will attempt to call you but if we cannot reach you, your account will automatically reset, and you can initiate the call when you\'re available.'},
        {title: 'What Affects Pricing?', body: 'The main expense is directly linked to the resources required for connecting to a hold line using VoIP calling systems and STT software. Getting through to a line during peak hours may take hours of calls. We continuously work to reduce costs, with savings passed on to our customers.'},
        {title: 'What Are Estimated Wait Times?', body: 'Estimated wait times indicate the time it takes to connect to a hold line. We base these estimates on Google\'s data and recent calls from that day, but we cannot guarantee their accuracy.'},
        {title: 'Are My Calls Recorded?', body: 'Not at all. We employ TTS (text-to-speech) technology for approximately 2-3 minutes of each call to capture wait times and call status, but this is discontinued before connecting calls.'},
        {title: 'Is My Call Secure?', body: 'Our software engineer has a strong background in I.T. security. We only use enterprise-grade databases, authentication, and VoIP services. If you have any concerns about our services, feel free to contact us by phone or video call to discuss further.'},
        {title: 'How to Contact Us', body: 'The quickest way to reach us is through the chat at the bottom left corner of your screen. Alternatively, you can email us at support@EDDCaller.com.'},
        {title: '', body: '<br><br><br><br><br>'},
      ],
      card: null,
      paymentSubmit: true,
      selected: null,
      options: [],
      isActiveOT: false,
      isActiveLT: false,
      number: null,
      uid: null,
      user: null,
      account: null,
      id: null,
      cost: '9.99',
      statdata: {},
      statfound: false,
      fbdata: {
        callStatus: "Done",
      },
      errors: [],
      masterpass: false,
      applePay: false,
      phoneNumber: null,
      bindProps: {
        mode: "international",
        defaultCountry: "US",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Enter your phone number",
        required: false,
        enabledCountryCode: false,
        enabledFlags: true,
        onlyCountries: ["US"],
        ignoredCountries: [],
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        wrapperClasses: "",
        inputClasses: "",
        dropdownOptions: {
          disabled: false,
          showFlags: true,
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        }
      }, 
      confirmationResult: null,
      otpnum: null,
      recaptchaVerifier: null,
      recaptchaWidgetId: null,
      confirmResult: null,
      smsSent: false,
      lines: [],
      caitems: [],
    };
  },
  async mounted() {
    let locationId = "KNBC0RXYPYK46";
    let appId = "sq0idp-6kqCeryaZPjeQPalLiyq4A";
    let that = this;

    const payments = Square.payments(appId, locationId);
    this.card = await payments.card();
    await this.card.attach('#card-container');

    // Only run if popup shows because this errors and kills rest of mounted
    if (this.uid == null) {
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('log-in', {
        'size': 'invisible',
        'callback': (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          console.log(response);
        }
      });
    }
  },
  methods: {
    handleDropdownChange() {
      firebase.firestore().collection("stats").doc(this.selected).onSnapshot(querySnapshot => {
        if (querySnapshot.exists) {  
          console.log(querySnapshot.data());
          this.statdata = querySnapshot.data();
          this.statfound = true;
        } else {
          this.statdata = null;
          this.statfound = false;
        }
      });
    },
    submit() {
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
      this.recaptchaVerifier.render().then((widgetId) => {
        this.recaptchaWidgetId = widgetId;
      });
            
      var number = this.phoneNumber;            
      firebase.auth().signInWithPhoneNumber(number, this.recaptchaVerifier)
        .then((confirmationResult) => {                
          this.confirmResult = confirmationResult;
          console.log(this.confirmResult);
          this.smsSent = true;
        })
        .catch((error) => {
          console.log("Sms not sent", error.message);
        });
    },
    verifyCode() {            
      this.confirmResult.confirm(this.otpnum)
        .then((result) => {
          var user = result.user;
          firebase.auth().onAuthStateChanged((user) => {
            if (user) {
              this.$refs["modal"].hide();
              this.number = user.phoneNumber;
              this.uid = user.uid;
              window.$chatwoot.setUser(this.uid, {
                name: this.uid,
                phone_number: "+1234567890"  // Add the phone number here
              });
              this.account = user;
              console.log(user);
              firebase.firestore().collection("accounts").doc(user.uid).onSnapshot(querySnapshot => {
                if (querySnapshot.exists) {  
                  console.log(querySnapshot.data());
                  this.fbdata = querySnapshot.data();
                } else {
                  console.log("cant get user data");
                }
              });
            } else {
              console.log('No user');
              this.user = null;
              this.$refs["modal"].show();
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSubmit() {
      // This doesn't work because the submit is turned off in the callback
      // this.paymentSubmit = true;
    },
    selectOption() {
      // document.getElementById("lifetime").classList.add('btn btn-outline-primary pr-btn');
    },
    async requestCardNonce(event) {
      event.preventDefault();

      try {
        const result = await this.card.tokenize();

        if (result.status === 'OK') {
          console.log(`Payment token is ${result.token}`);
          console.log(document.getElementById("options").value);
          
          // Can swap document.* with that.*
          axios.get('https://api.eddcaller.com/', { 
            params: {
              nonce: `${result.token}`, 
              uid: this.uid, 
              amount: this.cost, 
              state: document.getElementById("options").value
            } 
          }).then(response => {
            console.log(response.data);
            if (response.data == "COMPLETED") {
              gtag('event', 'conversion', {'send_to': 'AW-10801661095/h0xMCJaDs44YEKeJ0Z4o', 'transaction_id': `${result.token}`});
              gtag('event', 'purchase', {'send_to': 'G-YJX5RP9WZZ', 'transaction_id': `${result.token}`});

              this.$swal({
                position: 'top-end',
                icon: 'success',
                title: 'Payment Successful!',
                showConfirmButton: false,
                timer: 3000
              });
              
              if (this.autostartEnabled) {
                this.placeCall();
              }
            } else {
              this.$swal({
                position: 'top-end',
                icon: 'error',
                title: 'Payment Unsuccessful. Please check your information.',
                showConfirmButton: false,
                timer: 3000
              });
            }
          });
        }
      } catch (e) {
        console.error(e);
      }

      this.paymentSubmit = false;  
      setTimeout(() => this.paymentSubmit = true, 8000);
    },
    onComplete() {
    },
    placeCall() {
     axios.get('https://api.eddcaller.com/startcall', { params: {uid: this.uid, phone: this.number} });
    },
    pauseCall() {
     axios.get('https://api.eddcaller.com/pausecall', { params: {uid: this.uid} });
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.number = user.phoneNumber;
        this.uid = user.uid;
        this.account = user;
        
        firebase.firestore().collection("accounts").doc(user.uid).onSnapshot(querySnapshot => {
          if (querySnapshot.exists) {  
            this.fbdata = querySnapshot.data();
            
            window.$chatwoot.setUser(this.uid, {
              name: this.uid,
              phone_number: this.number,
            });
          } else {
            if (this.$route.query.offer) {
              this.cost = '5.00';
              console.log("Found offer: ", this.$route.query.offer);
              console.log("Found offer: ", this.fbdata);
              console.log("Found receipt: ", this.fbdata.receiptURL);
            }
          }
        });

        firebase.firestore().collection('lines').onSnapshot(snapshot => {
          this.lines = [];
          this.options = [{ value: null, text: 'Select Service' }];
          snapshot.forEach(doc => {
            let data = doc.data();
            data.id = doc.id;
            this.lines.push(data);
            this.options.push({value: doc.id, text: data.name});
          });
        });
        
        if(this.$route.query.line) {
          this.selected = this.$route.query.line;
          console.log("Found line ", this.selected);

          firebase.firestore().collection("stats").doc(this.selected).onSnapshot(querySnapshot => {
            if (querySnapshot.exists) {  
              console.log(querySnapshot.data());
              this.statdata = querySnapshot.data();
              this.statfound = true;
            } else {
              this.statdata = null;
              this.statfound = false;
            }
          });
        }
      } else {
        console.log('No user');
        this.user = null;
        this.$refs["modal"].show();
      }
    });
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.postList.filter(item => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every(v => item.title.toLowerCase().includes(v));
        });
      } else {
        return this.postList;
      }
    }
  },
  components: { Navbar, Footer },
};
</script>

<style>
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.7.2/font/bootstrap-icons.css");

/* Global Styles */
.dashboard-container {
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.dashboard-header h1 {
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.dashboard-divider {
  height: 4px;
  width: 80px;
  background-color: #007bff;
  margin: 0 auto 2rem;
  border-radius: 2px;
}

/* Card Styles */
.dashboard-card {
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.dashboard-card .card-header {
  background-color: #f8f9fa;
  padding: 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.dashboard-card .card-body {
  padding: 1.5rem;
}

.dashboard-card .card-footer {
  padding: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

/* Login Modal Styles */
.login-modal-content {
  padding: 1rem;
}

.logo-image {
  max-width: 200px;
  height: auto;
}

.otp-container {
  max-width: 300px;
  margin: 0 auto;
  padding: 1.5rem;
}

.otp-input {
  font-size: 1.25rem;
  letter-spacing: 2px;
  padding: 0.75rem;
}

.recaptcha-wrapper {
  width: 300px;
  margin: 1rem auto;
}

/* Payment Styles */
.payment-box {
  padding: 0.5rem;
}

.custom-select {
  height: 3rem;
  font-size: 1rem;
}

.stats-info {
  font-size: 0.9rem;
  color: #666;
}

.payment-form {
  margin-top: 1rem;
}

.card-container {
  min-height: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  background-color: #fff;
}

.payment-button {
  padding: 0.75rem 2rem;
  font-weight: 600;
}

.autostart-toggle {
  padding: 0.5rem;
}

.autostart-label {
  font-size: 0.9rem;
  color: #555;
}

/* Call Status Styles */
.call-status-indicator {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
}

.status-text {
  margin-left: 0.5rem;
  font-weight: 500;
}

.warning-icon {
  margin-right: 0.75rem;
  color: #f0ad4e;
}

.start-call-button {
  padding: 1rem 2.5rem;
  font-size: 1.25rem;
  font-weight: 600;
}

/* Table Styles */
.calling-hours h4 {
  color: #495057;
}

.table-container {
  overflow-x: auto;
  width: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.table {
  width: 100%;
  margin-bottom: 0;
}

.table th {
  background-color: #f8f9fa;
  color: #495057;
  font-weight: 600;
}

/* Profile Info Styles */
.profile-info {
  line-height: 1.6;
}

/* FAQ Sidebar Styles */
.faq-content {
  max-height: calc(100vh - 120px);
  overflow-y: auto;
}

.faq-item {
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
}

.faq-title {
  color: #007bff;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.faq-body {
  color: #555;
  font-size: 0.95rem;
}

/* Square Payment Styles */
.sq-input {
  border: 1px solid #dfe1e5;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #32325d;
  line-height: 24px;
  box-sizing: border-box;
}

.sq-input::placeholder {
  color: #aab7c4;
  opacity: 0.5;
}

/* Hero Section */
.hero-section {
  background-size: cover;
  background-position: center;
  padding: 2rem 0;
}

/* Miscellaneous Styles */
.alert {
  border-radius: 6px;
}

.alert-heading {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
</style>
